module.exports = __webpack_public_path__ + "static/media/横版视频.a241f9e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/横版视频.mp4
// module id = gfzJ
// module chunks = 3